import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ValidationMessagesService } from '../../validator/validation-messages.service';
import { PreAssessmentService } from '../../services/api-services/pre-assessments.service';

@Component({
  selector: 'app-smoking-status-change',
  templateUrl: './smoking-status-change.component.html',
  styleUrls: ['./smoking-status-change.component.scss'],
})
export class SmokingStatusChangeComponent implements OnInit {
  form: FormGroup = new FormGroup({});
  isLoading: boolean = false;
  constructor(
    public dialogRef: MatDialogRef<SmokingStatusChangeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private toast: ToastrService,
    private validationMessagesService: ValidationMessagesService,
    public preAssessmentService: PreAssessmentService,
  ) { }

  ngOnInit(): void {
    this.initializeForm();
  }

  initializeForm() {
    try {
      this.form = this.fb.group({
        id: [this.data?.item?.id],
        selectedLanguage: ['en'],
        RejectedReasonID: [''],
        user_id: [this.data?.item?.user_id || ''],
        status: [null],
        CustomMessage: [false],
        Message: [''],
        NotifyUsers: [false],
        NotifyUsersBy: this.fb.array([]),
      });
      const notifyUsersBy: string[] = [];
      notifyUsersBy.forEach((item) => {
        (this.form.get('NotifyUsersBy') as FormArray).push(this.fb.control(item));
      });
    } catch (error) {
      console.error('Error initializing form:', error);
    }
  }

  formSubmit() {
    const status = this.form.get('status')?.value;
    if (status == 0) {
      this.dialogRef.close(false);
      return;
    }
    this.isLoading = true;
    if (this.form.valid) {
      const payload = this.form.value;
      this.preAssessmentService.changeStatus(payload).subscribe(
        (res) => {
          if (res.body.success) {
            this.toast.success(res.body.message);
            this.isLoading = false;
            this.dialogRef.close({ payload, response: res.body });
          } else {
            this.toast.error(res.body.message);
            this.isLoading = false;
          }
        },
        (err) => {
          this.isLoading = false;
          console.error(err);
          this.toast.error('An error occurred while updating the status.');
        }
      );
    } else {
      this.validationMessagesService.validateAllFormFields(this.form);
    }
  }
}
